import styled, { keyframes, css } from "styled-components";
import iconPrevNext from '@assets/icons/icon-selection-next.png'; 

export const FramesSelection = styled.div`
    width: 100%; 
    z-index:2;
    .carousel-container {
        
    }
    .carousel {
        position: relative;
    }

    .carousel__images {
        display: flex;
        max-width: 100%;
        overflow-x: hidden;
        background-color:rgba(154,7,22,0.8);
        padding: 15px;
        @media only screen and (max-width: 480px) {
            padding: 10px;
        }
    }

    .carousel__image-selected {
        border: 3px solid #eee !important;
    }

    .carousel__image {
        height: 100px;
        min-width: 100px; 
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
        image-rendering: optimizeQuality;
        image-rendering: -webkit-optimize-contrast;
        vertical-align: middle;
        align-items: center;
        display: flex;
        text-align: center;
        justify-content: center;
        background-color: #4d4e4e;
        margin-right: 20px;
        cursor: pointer;
        @media only screen and (max-width: 480px) {
            height: 60px;
            min-width: 60px;
            margin-right: 10px;
        }
        strong {
            font-size: 14px;
            font-weight: normal;
        }
        span {
            border-radius: 100%;
            width: 50px;
            height: 50px;
            font-size: 13px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color:rgba(154,7,22,0.6);
            @media only screen and (max-width: 480px) {
                width: 30px;
                height: 30px;
                font-size: 12px;
            }
        }
    }
    
    .carousel__button {
        position: absolute;
        top: 40%;
        background-image: url(${iconPrevNext});
        image-rendering: optimizeQuality;
        image-rendering: -webkit-optimize-contrast;
        border: 0;
        width: 40px;
        height: 40px;
        background-size: contain;
        background-color: transparent;
        opacity: .85;
        cursor: pointer;
        @media only screen and (max-width: 480px) {
            top: 30%; 
        }
    }

    .carousel__button-left {
        left: 5px;
        transform: rotate(0.5turn);
    }

    .carousel__button-right {
        right: 5px;
    }
    .resize-drag {
        display: flex;
        alignItems: center;
        justifyContent: center;
        &.react-draggable-dragging {
            ${'' /* border: 1px dashed #ddd; */}
        }

        &.step-3 {
            &:hover, &:active {
                .rsz-wrapper {
                    .rsz-top, .rsz-right, .rsz-bottom, .rsz-left {
                        background-color: #fff;
                        opacity: 0.3;
                    }
                    .rsz-top {
                        top: 2px!important; 
                        height: 1px !important;}
                    .rsz-right {
                        right: 2px!important; 
                        width: 1px !important;}
                    .rsz-bottom {
                        bottom: 2px!important; 
                        height: 1px !important;}
                    .rsz-left {
                        left: 2px!important; 
                        width: 1px !important;}
                    .rsz{ 
                        background-color: #fff;
                        width: 5px !important;
                        height: 5px !important;
                        &-tr { 
                            right: 0px!important;
                            top: 0px!important;
                        }
                        &-tl {
                            top: 0px!important;
                            left: 0px!important;
                        }
                        &-br {
                            right: 0px!important;
                            bottom: 0px!important;
                        }
                        &-bl {
                            left: 0px!important;
                            bottom: 0px!important;
                        }
                    }
                }
            }
            
        }
    }
`
export const Carouselcontainer = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    max-width: ${({ maxWidth }) => maxWidth && `${maxWidth}px`};
    max-height: 480px;
    margin-top: 155px;
    margin-left: 10px;
    @media only screen and (max-width: 480px) {
        margin-top: 116px;
        max-height: 400px;
    }
    .selected-image {
        width: 100%;
        height: 100%;
        background-position: bottom;
        background-size: 100% 100%;
        image-rendering: optimizeQuality;
        image-rendering: -webkit-optimize-contrast;
        position: absolute;
        background-repeat: no-repeat;
        top: 0;
        &:hover, &:active {
            i { 
            background-color:rgba(154,7,22,0.6); 
            position: absolute; 
            top: 10%;
            left: 5%;
            width: 24px;
            height: 24px;
            border-radius: 100%;
            &:before, &:after {
                position: absolute;
                content: ' ';
                height: 16px;
                width: 2px;
                top: 5px;
                background-color: #fff;
            }
            &:before {
                transform: rotate(45deg);
            }
            &:after {
                transform: rotate(-45deg);
            }

        }
    }
        

        &.step-3 {
            background-size: contain;
            background-position: center;
            
        }
    }
`
export const FrameOverlay = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-size: 100% auto;
  background-position: bottom;
  z-index: 1;
  opacity: .95;
  .frames {
      border: 1px solid #fff;
      width:100%;
      display: flex;
  }
`;

export const FramedImage = styled.div`
    height: 100%;
    max-height: 570px;
    width: 100%;
    overflow: hidden;
`

export const Image = styled.div`
    height: 100%;
    max-height: 570px;
    width: 100%;
    background-size: contain;
`

 